
// Section with Editor
$(document).on('shopify:section:load', function(e){ 
  $('#' + e.target.id).find('[data-section]').sectionJs();
}).ready(function() {
  $('[data-section]').each(function(){ $(this).sectionJs() });
});

$.fn.sectionJs = function(){
  var $this = this;
  if($this.data('section') == "FullWidthSlider") {
    $this.FullWidthSliderActive();
  }else if($this.data('section') == "BoxWidthSlider") {
    $this.BoxWidthSlider();
  }else if($this.data('section') == "HeaderSections") {
    $this.HeaderSectionsActivation();
  }else if($this.data('section') == "TabWithProduct") {
    $this.find('.product_column5').TabWithProduct();
  }else if($this.data('section') == "FeaturedCollection") {
    $this.find('.product_column5').FeaturedCollection();
  }else if($this.data('section') == "BannerWithCollection") {
    $this.find('.product_column2').BannerWithCollection();
  }else if($this.data('section') == "LatestBlog") {
    $this.find('.blog_column3').LatestBlog();
  }else if($this.data('section') == "BrandLogo") {
    $this.find('.brand_container').BrandLogo();
  }else if($this.data('section') == "CollectionThumbnail") {
    $this.find('.product_column1').CollectionThumbnail();
  }else if($this.data('section') == "SectionWithSidebar") {
    $this.SectionWithSidebar();
  }else if($this.data('section') == "SectionWithSidebar2") {
    $this.SectionWithSidebar2();
  }else if($this.data('section') == "CustomCollection") {
    $this.find('.productpage_column4_2').CustomCollection();
  }else if($this.data('section') == "FaqTestimonial") {
    $this.TestimonialActive();
  }else if($this.data('section') == "MultipleBanner") {
    $this.MultipleBanner();
  }else if($this.data('section') == "FeaturedProduct") {
    $this.FeaturedProduct();
  }else if($this.data('section') == "AboutGallery") {
    $this.AboutGallery();
  }else if($this.data('section') == "AboutInfo") {
    $this.AboutInfo();
  }else if($this.data('section') == "Service1") {
    $this.Service1();
  }else if($this.data('section') == "Service2") {
    $this.Service2();
  }else if($this.data('section') == "Footer") {
    $this.Footer();
  }else if($this.data('section') == "CollectionTemplate") {
    $this.CollectionTemplate();
  }else if($this.data('section') == "ProductTemplate") {
    $this.ProductTemplate();
  }else{}   
}

// Full width slider active js
$.fn.FullWidthSliderActive = function() {
  var $carousel = $('[data-owl-carousel]');
  var $OwlFullWidthSlider = $('.slider_area');

  if ($carousel.length) {
    $carousel.each(function() {
      $(this).owlCarousel($(this).data('owl-carousel'));
    });
  }

  $OwlFullWidthSlider.owlCarousel();

  /*---background image---*/
  function dataBackgroundImage() {
    $('[data-bgimg]').each(function () {
      var bgImgUrl = $(this).data('bgimg');
      $(this).css({
        'background-image': 'url(' + bgImgUrl + ')', // + meaning concat
      });
    });
  }
  jQuery(document).ready(function(){
    dataBackgroundImage();
  });
};

// Box width slider active js
$.fn.BoxWidthSlider = function() {
  var $carousel2 = $('[data-owl-carousel]');
  var $OwlBoxWidthSlider = $('.slider_area');

  if ($carousel2.length) {
    $carousel2.each(function() {
      $(this).owlCarousel($(this).data('owl-carousel'));
    });
  }

  $OwlBoxWidthSlider.owlCarousel();

  /*---background image---*/
  function dataBackgroundImage() {
    $('[data-bgimg]').each(function () {
      var bgImgUrl = $(this).data('bgimg');
      $(this).css({
        'background-image': 'url(' + bgImgUrl + ')', // + meaning concat
      });
    });
  }
  jQuery(document).ready(function(){
    dataBackgroundImage();
  });
};

// Header Section active js
$.fn.HeaderSectionsActivation = function() {
  /*---search box slideToggle---*/
  $(".search_box > a").on("click", function() {
    $(this).toggleClass('active');
    $('.search_widget').slideToggle('medium');
  }); 


  /*---header account slideToggle---*/
  $(".header_account > a").on("click", function() {
    $(this).toggleClass('active');
    $('.dropdown_account').slideToggle('medium');
  }); 

  /*---slide toggle activation---*/
  $('.mini_cart_wrapper > a').on('click', function(event){
    if($(window).width() < 991){
      $('.mini_cart').slideToggle('medium');
    }
  }); 


  /*---canvas menu activation---*/
  $('.canvas_open').on('click', function(){
    $('.offcanvas_menu_wrapper,.off_canvars_overlay').addClass('active')
  });

  $('.canvas_close,.off_canvars_overlay').on('click', function(){
    $('.offcanvas_menu_wrapper,.off_canvars_overlay').removeClass('active')
  });



  /*---Off Canvas Menu---*/
  var $offcanvasNav = $('.offcanvas_main_menu'),
      $offcanvasNavSubMenu = $offcanvasNav.find('.sub-menu');
  $offcanvasNavSubMenu.parent().prepend('<span class="menu-expand"><i class="fa fa-angle-down"></i></span>');

  $offcanvasNavSubMenu.slideUp();

  $offcanvasNav.on('click', 'li a, li .menu-expand', function(e) {
    var $this = $(this);
    if ( ($this.parent().attr('class').match(/\b(menu-item-has-children|has-children|has-sub-menu)\b/)) && ($this.attr('href') === '#' || $this.hasClass('menu-expand')) ) {
      e.preventDefault();
      if ($this.siblings('ul:visible').length){
        $this.siblings('ul').slideUp('slow');
      }else {
        $this.closest('li').siblings('li').find('ul:visible').slideUp('slow');
        $this.siblings('ul').slideDown('slow');
      }
    }
    if( $this.is('a') || $this.is('span') || $this.attr('clas').match(/\b(menu-expand)\b/) ){
      $this.parent().toggleClass('menu-open');
    }else if( $this.is('li') && $this.attr('class').match(/\b('menu-item-has-children')\b/) ){
      $this.toggleClass('menu-open');
    }
  });
  
  /*---categories slideToggle---*/
  $(".categories_title").on("click", function() {
    $(this).toggleClass('active');
    $('.categories_menu_toggle').slideToggle('medium');
  }); 

  /*---widget sub categories---*/
  $(".sub_categories1 > a").on("click", function() {
    $(this).toggleClass('active');
    $('.dropdown_categories1').slideToggle('medium');
  }); 

  /*---widget sub categories---*/
  $(".sub_categories2 > a").on("click", function() {
    $(this).toggleClass('active');
    $('.dropdown_categories2').slideToggle('medium');
  }); 

  /*---widget sub categories---*/
  $(".sub_categories3 > a").on("click", function() {
    $(this).toggleClass('active');
    $('.dropdown_categories3').slideToggle('medium');
  }); 


  /*----------  Category more toggle  ----------*/

  $(".categories_menu_toggle li.hidden").hide();
  $("#more-btn").on('click', function (e) {

    e.preventDefault();
    $(".categories_menu_toggle li.hidden").toggle(500);
    var htmlAfter = '<i class="fa fa-minus" aria-hidden="true"></i> Less Categories';
    var htmlBefore = '<i class="fa fa-plus" aria-hidden="true"></i> More Categories';


    if ($(this).html() == htmlBefore) {
      $(this).html(htmlAfter);
    } else {
      $(this).html(htmlBefore);
    }
  });
  
  /*---Category menu---*/
  function categorySubMenuToggle(){
    $('.categories_menu_toggle li.menu_item_children > a').on('click', function(){
      if($(window).width() < 991){
        $(this).removeAttr('href');
        var element = $(this).parent('li');
        if (element.hasClass('open')) {
          element.removeClass('open');
          element.find('li').removeClass('open');
          element.find('ul').slideUp();
        }
        else {
          element.addClass('open');
          element.children('ul').slideDown();
          element.siblings('li').children('ul').slideUp();
          element.siblings('li').removeClass('open');
          element.siblings('li').find('li').removeClass('open');
          element.siblings('li').find('ul').slideUp();
        }
      }
    });
    $('.categories_menu_toggle li.menu_item_children > a').append('<span class="expand"></span>');
  }
  categorySubMenuToggle();
  
};

// Tab With Product active js
$.fn.TabWithProduct = function() {
  var $TabWithProductVAR = this;
  $TabWithProductVAR.slick({
    adaptiveHeight: true,
    speed: 1000,prevArrow: '<button type="button" class="slick-prev"><i class="ion-ios-arrow-left"></i></button>',
    nextArrow: '<button type="button" class="slick-next"><i class="ion-ios-arrow-right"></i></button>',});
  
  $("img.lazyload").lazyload();
};

// Featured Collection active js
$.fn.FeaturedCollection = function() {
  var $FeaturedCollectionVAR = this;
  $FeaturedCollectionVAR.slick({
    adaptiveHeight: true,
    speed: 1000,prevArrow: '<button type="button" class="slick-prev"><i class="ion-ios-arrow-left"></i></button>',
    nextArrow: '<button type="button" class="slick-next"><i class="ion-ios-arrow-right"></i></button>',});
  
  $("img.lazyload").lazyload();
};

// Banner With Collection active js
$.fn.BannerWithCollection = function() {
  var $BannerWithCollectionVAR = this;
  $BannerWithCollectionVAR.slick({
    adaptiveHeight: true,
    speed: 1000,prevArrow: '<button type="button" class="slick-prev"><i class="ion-ios-arrow-left"></i></button>',
    nextArrow: '<button type="button" class="slick-next"><i class="ion-ios-arrow-right"></i></button>',});
  $("img.lazyload").lazyload();
};

// Latest Blog active js
$.fn.LatestBlog = function() {
  var $LatestBlogVAR = this;
  $LatestBlogVAR.slick({
    adaptiveHeight: true,
    speed: 1000,prevArrow: '<button type="button" class="slick-prev"><i class="ion-ios-arrow-left"></i></button>',
    nextArrow: '<button type="button" class="slick-next"><i class="ion-ios-arrow-right"></i></button>',});
  
  $("img.lazyload").lazyload();
};

// Brand Logo active js
$.fn.BrandLogo = function() {
  var $BrandLogoVAR = this;
  $BrandLogoVAR.slick({
    adaptiveHeight: true,
    speed: 1000,prevArrow: '<button type="button" class="slick-prev"><i class="ion-ios-arrow-left"></i></button>',
    nextArrow: '<button type="button" class="slick-next"><i class="ion-ios-arrow-right"></i></button>',});
  
  $("img.lazyload").lazyload();
};

// Collection Thumbnail active js
$.fn.CollectionThumbnail = function() {
  var $CollectionThumbnailVAR = this;
  $CollectionThumbnailVAR.slick({
    adaptiveHeight: true,
    speed: 1000,prevArrow: '<button type="button" class="slick-prev"><i class="ion-ios-arrow-left"></i></button>',
    nextArrow: '<button type="button" class="slick-next"><i class="ion-ios-arrow-right"></i></button>',responsive: [{
      breakpoint: 992,
      settings: {
        slidesToShow: 2
      }
    },
                 {
                   breakpoint: 768,
                   settings: {
                     slidesToShow: 1
                   }
                 }]
  });
  
  $("img.lazyload").lazyload();
};

// Section With Sidebar active js
$.fn.SectionWithSidebar = function() {

  var $DealCollection = $('.deals3_column1_1');
  $DealCollection.slick({
    adaptiveHeight: true,
    speed: 1000,prevArrow: '<button type="button" class="slick-prev"><i class="ion-ios-arrow-left"></i></button>',
    nextArrow: '<button type="button" class="slick-next"><i class="ion-ios-arrow-right"></i></button>',slidesToShow: 1,
    responsive: [{
      breakpoint: 992,
      settings: {
        slidesToShow: 1
      }
    },
                 {
                   breakpoint: 768,
                   settings: {
                     slidesToShow: 1,
                     arrows: false
                   }
                 },
                 {
                   breakpoint: 480,
                   settings: {
                     slidesToShow: 1,
                     arrows: false
                   }
                 }]
  });
  
  var $ThumbCollection = $('.smallp_column2_1');
  $ThumbCollection.slick({
    adaptiveHeight: true,
    speed: 1000,prevArrow: '<button type="button" class="slick-prev"><i class="ion-ios-arrow-left"></i></button>',
    nextArrow: '<button type="button" class="slick-next"><i class="ion-ios-arrow-right"></i></button>',});
  
  var $FeaturedCollection = $('.product3_column3_1');
  $FeaturedCollection.slick({
    adaptiveHeight: true,
    speed: 1000,prevArrow: '<button type="button" class="slick-prev"><i class="ion-ios-arrow-left"></i></button>',
    nextArrow: '<button type="button" class="slick-next"><i class="ion-ios-arrow-right"></i></button>',});
  
  $("img.lazyload").lazyload();

};

// Section With Sidebar 2 active js
$.fn.SectionWithSidebar2 = function() {

  var $ThumbCollection2 = $('.smallp4_left_column1');
  $ThumbCollection2.slick({
    adaptiveHeight: true,
    speed: 1000,prevArrow: '<button type="button" class="slick-prev"><i class="ion-ios-arrow-left"></i></button>',
    nextArrow: '<button type="button" class="slick-next"><i class="ion-ios-arrow-right"></i></button>',slidesToShow: 1,
    responsive: [{
      breakpoint: 992,
      settings: {
        slidesToShow: 1
      }
    },
                 {
                   breakpoint: 768,
                   settings: {
                     slidesToShow: 1
                   }
                 },
                 {
                   breakpoint: 480,
                   settings: {
                     slidesToShow: 1
                   }
                 }]
  });
  
  
  var $DealCollection2 = $('.deals3_column1');
  $DealCollection2.slick({
    adaptiveHeight: true,
    speed: 1000,prevArrow: '<button type="button" class="slick-prev"><i class="ion-ios-arrow-left"></i></button>',
    nextArrow: '<button type="button" class="slick-next"><i class="ion-ios-arrow-right"></i></button>',slidesToShow: 1,
    responsive: [{
      breakpoint: 992,
      settings: {
        slidesToShow: 1
      }
    },
                 {
                   breakpoint: 768,
                   settings: {
                     slidesToShow: 1
                   }
                 },
                 {
                   breakpoint: 480,
                   settings: {
                     slidesToShow: 1
                   }
                 }]
  });
  
  
  var $carousel3 = $('[data-owl-carousel]');
  var $OwlTestimonialSlider = $('.testimonial_column1');

  if ($carousel3.length) {
    $carousel3.each(function() {
      $(this).owlCarousel($(this).data('owl-carousel'));
    });
  }

  $OwlTestimonialSlider.owlCarousel();
  
  var $TabWithProduct2 = $('.product3_column3');
  $TabWithProduct2.slick({
    adaptiveHeight: true,
    speed: 1000,prevArrow: '<button type="button" class="slick-prev"><i class="ion-ios-arrow-left"></i></button>',
    nextArrow: '<button type="button" class="slick-next"><i class="ion-ios-arrow-right"></i></button>',});
  
  var $ThumbCollection3 = $('.smallp_column2');
  $ThumbCollection3.slick({
    adaptiveHeight: true,
    speed: 1000,prevArrow: '<button type="button" class="slick-prev"><i class="ion-ios-arrow-left"></i></button>',
    nextArrow: '<button type="button" class="slick-next"><i class="ion-ios-arrow-right"></i></button>',});
  
  $("img.lazyload").lazyload();

};

// Related Product active js
$.fn.CustomCollection = function() {
  var $CustomCollectionActive = this;
  $CustomCollectionActive.slick({
    adaptiveHeight: true,
    speed: 1000,prevArrow: '<button type="button" class="slick-prev"><i class="ion-ios-arrow-left"></i></button>',
    nextArrow: '<button type="button" class="slick-next"><i class="ion-ios-arrow-right"></i></button>',});
  
  $("img.lazyload").lazyload();
};

// Testimonial active js
$.fn.TestimonialActive = function() {
  var $carousel4 = $('[data-owl-carousel]');
  var $OwlTestimonialSlider2 = $('.testimonial-two');

  if ($carousel4.length) {
    $carousel4.each(function() {
      $(this).owlCarousel($(this).data('owl-carousel'));
    });
  }

  $OwlTestimonialSlider2.owlCarousel();
};

// Multiple Banner active js
$.fn.MultipleBanner = function() {
  $("img.lazyload").lazyload();
};

// Featured product active js
$.fn.FeaturedProduct = function() {
  $("img.lazyload").lazyload();
};

// About Gallery active js
$.fn.AboutGallery = function() {
  $("img.lazyload").lazyload();
};

// About Info active js
$.fn.AboutInfo = function() {
  $("img.lazyload").lazyload();
};

// Service 1 active js
$.fn.Service1 = function() {
  $("img.lazyload").lazyload();
};

// Service 2 active js
$.fn.Service2 = function() {
  $("img.lazyload").lazyload();
};

// Footer active js
$.fn.Footer = function() {
  $("img.lazyload").lazyload();
};

// Collection Template active js
$.fn.CollectionTemplate = function() {
  $("img.lazyload").lazyload();
};

// Product Template active js
$.fn.ProductTemplate = function() {
  $("img.lazyload").lazyload();
};

(function($) {
  "use strict";

  jQuery(document).ready(function(){

    new WOW().init();  


    /*--- Tooltip Active---*/
    $('.action_links ul li a,.add_to_cart a,.footer_social_link ul li a').tooltip({
      animated: 'fade',
      placement: 'top',
      container: 'body'
    });
    
    
    $("img.lazyload").lazyload();


  });
  
})(jQuery);